import { toLower } from "lodash"
import { Link } from "react-router-dom"
import { Button } from "../../../components/Button"
import { MarkText } from "../../../components/MarkText"
import { Paragraph } from "../../../components/Text"
import { Upload } from "../../../components/Upload"
import { RemoveIcon } from "../../../icons/RemoveIcon"
import { UploadIcon } from "../../../icons/UploadIcon"
import { formatDate, highlightText } from "../../../utils"

export const services = ({ tab, shcRead, shcWrite, uploadFile, context, pathname, search, deleteItem }) => {

    const tabs = {
        shc: {
            enabled: shcRead,
            breadcrumbs: [
                { title: "Services", href: "/services" },
                { title: "Recent Data", href: "/services/shc/nodes" }, { title: "Uploads" }
            ],
            header: shcWrite &&
                <Upload
                    accept=".xml"
                    multiple={true}
                    customRequest={uploadFile}
                >
                    <Button onClick={(e) => null}>
                        <UploadIcon size={20} />
                        Upload SHC data
                    </Button>
                </Upload>,
            columns: [
                {
                    title: "Uploaded Date",
                    dataIndex: "uploadDatetime",
                    width: 180,
                    defaultSortOrder: "desc",
                    render: (text, record, index) => <MarkText title={text} text={highlightText(formatDate(text, "YYYY-MM-DD HH:mm:ss"), context)} />,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("uploadDatetime") && a.uploadDatetime) return a.uploadDatetime.localeCompare(b.uploadDatetime) },
                },
                {
                    title: "File Name",
                    dataIndex: "fileName",
                    render: (text, record, index) => (
                        <Link to={{pathname: `${pathname}/${toLower(record.uploadRef)}`, state: { from: pathname + search }}}>
                            <MarkText title={text} text={highlightText(text, context)} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("fileName") && a.fileName) return a.fileName.localeCompare(b.fileName) }
                },
                {
                    title: "Node",
                    dataIndex: "nodeName",
                    width: 100,
                    render: (text, record, index) => <MarkText title={text} text={highlightText(text, context)} />,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("nodeName") && a.nodeName) return a.nodeName.localeCompare(b.nodeName) }
                },
                {
                    title: "Uploaded By",
                    dataIndex: "uploadedBy",
                    render: (text, record, index) => <MarkText title={text} text={highlightText(text, context)} />,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("uploadedBy") && a.uploadedBy) return a.uploadedBy.localeCompare(b.uploadedBy) }
                },
                {
                    dataIndex: 'remove',
                    render: (text, record, index) =>
                    shcWrite &&
                        <RemoveIcon
                            onClick={() => deleteItem({ content: <Paragraph>Are you sure you want to delete the <span>{record.fileName}</span> and all its data?</Paragraph>, values: record.uploadRef })}
                            size={20}
                            color="var(--sp-label-color)"
                            hoverColor="var(--sp-error-color)"
                        />,
                    width: 50,
                }
            ]
        }
    };

    return tabs[tab];
};